import { render, staticRenderFns } from "./AddSliceProfile.vue?vue&type=template&id=5b2c7a49&"
import script from "./AddSliceProfile.vue?vue&type=script&lang=js&"
export * from "./AddSliceProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports